import React from 'react';
import { Card } from './ui/card';

const MAP = {
  gruen: { color: 'bg-green-500', text: 'text-white', label: 'Leicht', ring: 'ring-green-200' },
  orange: { color: 'bg-orange-500', text: 'text-white', label: 'Mittel', ring: 'ring-orange-200' },
  rot: { color: 'bg-red-600', text: 'text-white', label: 'Schwer', ring: 'ring-red-200' },
};

function normalize(value, fallback) {
  if (!value) return null;
  const v = String(value).toLowerCase();
  if (v === 'gruen' || v === 'grün' || v === 'green') return 'gruen';
  if (v === 'orange' || v === 'mittel' || v === 'yellow') return 'orange';
  if (v === 'rot' || v === 'red' || v === 'schwer' || v === 'totalschaden') return 'rot';
  if (v === 'leichter_schaden') return 'gruen';
  if (v === 'mittlerer_schaden') return 'orange';
  if (v === 'schwerer_schaden' || v === 'wirtschaftlicher_totalschaden') return 'rot';
  return fallback || null;
}

export default function SeverityBadge({ ampel, ampelLabel, gesamt, size = 'md', testid = 'severity-badge' }) {
  const key = normalize(ampel, normalize(gesamt));
  const cfg = key ? MAP[key] : null;
  if (!cfg) return null;
  const label = ampelLabel || cfg.label;
  const sizeCls = size === 'sm'
    ? 'h-6 w-6 text-[10px]'
    : size === 'lg'
    ? 'h-12 w-12 text-base'
    : 'h-8 w-8 text-xs';
  return (
    <div className="inline-flex items-center gap-2" data-testid={testid}>
      <div className={`rounded-full ${cfg.color} ${cfg.text} ${sizeCls} flex items-center justify-center font-bold ring-4 ${cfg.ring}`}>●</div>
      <div>
        <div className="text-xs text-slate-500 uppercase tracking-wide">Schadensgrad</div>
        <div className={`font-heading font-semibold ${size === 'lg' ? 'text-xl' : 'text-base'}`}>{label}</div>
      </div>
    </div>
  );
}

export function SeverityDot({ ampel, gesamt }) {
  const key = normalize(ampel, normalize(gesamt));
  const cfg = key ? MAP[key] : null;
  if (!cfg) return null;
  return <span className={`inline-block w-2.5 h-2.5 rounded-full ${cfg.color} ring-2 ${cfg.ring}`} />;
}
